import React, { useMemo } from "react";

import { FilterLabel } from "./filter_label";

type UseFilterLabel = {
  name: string;
  title: string;
};

type UseFilterLabelReturn = {
  label: JSX.Element;
};

export const useFilterLabel = ({ name, title }: UseFilterLabel): UseFilterLabelReturn => {
  const label = useMemo(() => <FilterLabel name={name} title={title} />, [name, title]);
  return {
    label
  };
};
